import { event as sendEvent } from '@zillow/universal-analytics';
import { getCmsInfoForPage } from './getCmsInfoForPage';
import type { CmsInfo } from './getCmsInfoForPage';
import type { INewLaneProperties } from '@zillow/universal-analytics';

// https://dataportal.zillowgroup.net/event-registry/5030
const CMS_OPEN_ENVELOPE = {
  event_type_id: '5030',
  event_type_version_id: '1',
  event_template_id: '297',
  event_template_version_id: '1',
};
// https://dataportal.zillowgroup.net/event-registry/2051
const CMS_CLOSE_ENVELOPE = {
  event_type_id: '2051',
  event_type_version_id: '1',
  event_template_id: '126',
  event_template_version_id: '1',
};
const MODAL_TRIGGER = {
  trigger_type_nm: 'interaction',
  trigger_location_nm: 'cms',
  trigger_source_nm: 'cms_modal',
  trigger_object_nm: 'no_trigger_object',
};

const toModalCmsInfo = (pageProps: Record<string, unknown> | undefined) => ({
  block_id: '',
  block_type_cd: 'modal_dialog',
  ...getCmsInfoForPage(pageProps),
});

const sendModalEvent = (
  envelope: CmsModalEvent['envelope'],
  semanticEventName: string,
  pageProps: Record<string, unknown> | undefined,
) => {
  const properties: CmsModalEvent = {
    envelope,
    clickstream_trigger: MODAL_TRIGGER,
    semantic: { semantic_event_nm: semanticEventName },
    cms_info: toModalCmsInfo(pageProps),
  };

  return sendEvent(properties);
};

export const emitVideoCtaOpenEvent = (pageProps: Record<string, unknown> | undefined) =>
  sendModalEvent(CMS_OPEN_ENVELOPE, 'cms_open', pageProps);

export const emitVideoCtaCloseEvent = (pageProps: Record<string, unknown> | undefined) =>
  sendModalEvent(CMS_CLOSE_ENVELOPE, 'cms_close', pageProps);

type CmsModalEvent = INewLaneProperties & {
  cms_info: CmsInfo & { block_id: string; block_type_cd: string };
};
